import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import moment from 'moment'
import momentHelper from 'scoreboard/components/moment-helper'

function dateValidatorFactory(format) {
	function dateValidator(val) {
		if (_.isEmpty(val)) {
			return
		}

		let strict = true
		if (!moment(val, format, momentHelper.STRICT).isValid()) {
			return i18n.get('common.error.date.tooltip')
		}
	}
	return dateValidator
}

export default dateValidatorFactory

dateValidatorFactory.__filename__ = 'components/validators/date-validator-factory.js'
